import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../config/config.js";

import Button from "@mui/joy/Button";
import Add from "@mui/icons-material/Add";

import { useSelector } from "react-redux";

// toast
import { toast } from "react-hot-toast";

import ModalAreaSelect from "../../components/Modals/ModalAreaSelect/ModalAreaSelect";
import ModalCreateEvent from "./ModalCreateEvent/ModalCreateEvent";

const CreateEvent = () => {
  const [openModal, setOpenModal] = useState(false);
  const [eventos, setEventos] = useState([]);
  const [openModalCreateEvent, setOpenModalCreateEvent] = useState(false)

  const [loading, setLoading] = useState(false);

  const yearSelected = useSelector((state) => state.year.yearSelected);

  const [selectedEvento, setSelectedEvento] = useState(null);
  const [selectedEventoIndex, setSelectedEventoIndex] = useState(null);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleOpenModalCreateEvent = () => {
    setOpenModalCreateEvent(true);
  }

  const handleClick = async (evento, index) => {
    if (evento === selectedEvento && index === selectedEventoIndex) {
      setSelectedEventoIndex(null);
      setSelectedEvento(null);
    } else {
      setSelectedEventoIndex(index);
      setSelectedEvento(evento);
    }
  };

  useEffect(() => {
    setEventos([]);
    const fetchEventos = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://cloud-master.perufedup.com/public/events/?periodo=${yearSelected}`,
          { withCredentials: false }
        );
        setEventos(response.data);
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };
    if(yearSelected) {
      fetchEventos();
    }
  }, [openModal, yearSelected]);

  const handleSave = async () => {
    try {
      await axios.post(`${API_BASE_URL}/championship`, {
        idchampionship: selectedEvento.idevent,
        name: selectedEvento.name,
        periodo: selectedEvento.periodo,
        startdate: selectedEvento.startdate,
        enddate: selectedEvento.enddate,
        image_path: selectedEvento.logo,
        place: selectedEvento.place,
        iddepartamento: 1,
      });

      setOpenModal(false);

      toast.success("¡Evento Creado Exitosamente!");
    } catch (error) {
      console.error("Error en crear un campeonato", error);
      toast.error("¡Hubo un Problema al Crear el Evento!");
    }
  };

  return (
    <>
      <div className="bg-white p-5 rounded-2xl dark:bg-gray-600 dark:text-gray-300 flex-1">
        <div>
          <h5 className="mb-2 text-2xl font-medium font-bold text-gray-700 dark:text-neutral-50">
            Crear Evento
          </h5>
        </div>
        <div style={{ display: "flex", gap: "5px" }}>
          <Button startDecorator={<Add />} onClick={() => handleOpenModal()} style={{
            marginBottom: "3.5px"
          }}>
            Añadir Evento (API)
          </Button>
          <Button startDecorator={<Add />} onClick={() => handleOpenModalCreateEvent()}>
            Crear Evento
          </Button>
        </div>
      </div>
      {
        openModal && (
          <ModalAreaSelect
            elementos={eventos}
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleSaveElemento={handleSave}
            loading={loading}
            handleClick={handleClick}
            selectedIndex={selectedEventoIndex}
            titulo="Evento"
          />
        )
      }
      {
        openModalCreateEvent && (
          <ModalCreateEvent
            open={openModalCreateEvent}
            setOpen={setOpenModalCreateEvent}
          />
        )
      }
    </>
  );
};

export default CreateEvent;
